import { Button } from "@mui/material";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Table = ({ tableData, header, headersData,loading}) => {
  // Extract headers dynamically if data is available

  // const headersData1 = tableData && tableData?.length > 0 ? Object.keys(tableData[0]) : [];
// let loading = true

  // Function to render skeleton rows while loading
  const renderSkeletonRows = () => {
    return Array.from({ length: 5 }).map((_, i) => (
      <tr key={`skeleton-${i}`}>
      
        {headersData.map((_, index) => (
          <td key={index} style={cellStyle}>
            <Skeleton width={150} height={20} />
          </td>
        ))}
        <td style={cellStyle}>
          <div style={{ display: "flex", gap: "8px" }}>
          <Skeleton width={150} height={20} />
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <>
      {loading ? (
        <table style={tableStyle}>
          <thead>
            <tr className={`header_${header}`}>
              <th style={headerStyle}> <Skeleton width={30} height={20} /></th>
              {headersData.map((key, index) => (
                <th style={{paddingLeft:"5px"}} key={index}>
                  <Skeleton width={100} height={20} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{renderSkeletonRows()}</tbody>
        </table>
      ) : tableData?.length === 0 ? (
        <p>No data available</p>
      ) : (
        <table style={tableStyle}>
          <thead>
            <tr className={`header_${header}`}>
              <th style={{textAlign:"center"}}>#</th>
              {headersData.map((key, index) => (
                <th key={index} style={headerStyle}>
                  {key}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData && tableData.map((item, index) => (
              <tr key={index}>
                <td style={cellStyle1}>{index + 1}</td>
                <td style={cellStyle}>
                    {item.policy_section || 'N/A'}
                  </td>
                  <td style={cellStyle}>
                    {item.compliance_status || 'N/A'}
                  </td>
                  <td style={cellStyle}>
                    {item.observations || 'N/A'}
                  </td>
              
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

// Table styles
const tableStyle = {
  width: "100%",
  border: "1px solid #eee",
  borderCollapse: "collapse",
};

const headerStyle = {
  border: "1px solid #eee",
  padding: "5px",
  // textAlign: "center",
};

const cellStyle = {
  border: "1px solid #eee",
  padding: "5px",
};
const cellStyle1 = {
  border: "1px solid #eee",
  padding: "5px",
  textAlign:"center"
};

export default Table;
